import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "col-2 left-margin no-print gt-xs" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "col-1 left-margin print gt-xs" }, null, -1)
const _hoisted_4 = { class: "col q-pl-md q-pr-md" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "col-2 right-margin no-print gt-xs" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "col-1 right-margin print gt-xs" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _hoisted_5,
    _hoisted_6
  ]))
}